/**
 * How long a funnel waits for its email capture before moving on.
 *
 * The wait exists so the `_funnel_session` cookie is in place before the rating
 * starts, since the completion PATCH needs it to find the capture. The bound
 * exists because that is a reporting concern and the visitor's funnel is not: a
 * slow capture must cost them a moment, not their place in the flow. Anything
 * still in flight past this is covered by the captured email travelling with the
 * completion instead.
 */
const EMAIL_CAPTURE_WAIT_MS = 2500;

/**
 * Waits for the email capture, but not indefinitely.
 *
 * Shared by both funnels deliberately. They have the same gate, the same race
 * and the same fallback, and letting the two drift apart is how one of them ends
 * up quietly broken while the other is fixed — see FFH-2376.
 *
 * @param capture The in-flight capture request.
 */
export const awaitEmailCaptureWithinBudget = async (
  capture: Promise<unknown>
): Promise<void> => {
  await Promise.race([
    capture,
    new Promise((resolve) => {
      setTimeout(resolve, EMAIL_CAPTURE_WAIT_MS);
    })
  ]);
};
